import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    heading: "Introduction",
    paragraphs: [
      "These Terms & Conditions govern your use of www.30north.ca, operated by 30 North Transportation Inc. (\u201c30 NORTH\u201d, \u201cwe\u201d, \u201cus\u201d). By using this website, you accept these Terms & Conditions. If you do not agree with them, please do not use this website.",
    ],
  },
  {
    heading: "Use of This Website",
    paragraphs: [
      "This website is provided for general information about 30 NORTH and its transportation and logistics services, and to allow you to contact us and submit quote requests. You agree to use this website lawfully and not to misuse it, interfere with its operation, or attempt to access it in unauthorized ways.",
    ],
  },
  {
    heading: "Transportation Services",
    paragraphs: [
      "The services described on this website — including full and partial truckload transportation, dedicated transportation, expedited transportation, specialized and white-glove delivery, and 3PL and freight brokerage — are general descriptions of the transportation solutions 30 NORTH can provide or coordinate.",
      "The details of any specific shipment, including equipment, scheduling, handling and pricing, are determined and confirmed individually between 30 NORTH and the customer.",
    ],
  },
  {
    heading: "Quote Requests",
    paragraphs: [
      "Submitting a quote request through this website is an inquiry, not a booking. A quote request does not create a shipment, a commitment, or a contract. Transportation is arranged only once the shipment details have been reviewed and confirmed between you and 30 NORTH.",
    ],
  },
  {
    heading: "Pricing and Availability",
    paragraphs: [
      "Any pricing or availability referenced in a quote is based on the information provided at the time of the request and may change if shipment details, requirements, timing or market conditions change. Pricing and transportation availability are not confirmed until agreed between you and 30 NORTH.",
    ],
  },
  {
    heading: "Customer Responsibilities",
    paragraphs: [
      "When requesting or arranging transportation, you are responsible for providing accurate and complete information about your shipment, including its contents, size, weight, handling needs and pickup and delivery details. You are responsible for ensuring that your goods are lawful to transport and appropriately packaged unless other arrangements have been made with 30 NORTH.",
    ],
  },
  {
    heading: "Third-Party / Partner Transportation",
    paragraphs: [
      "Depending on the requirements of a shipment, transportation may be arranged through trusted partner carriers. In those cases, 30 NORTH coordinates the transportation and remains your point of contact. Specific terms for a shipment may depend on the transportation arrangement made for it.",
    ],
  },
  {
    heading: "Website Content",
    paragraphs: [
      "The content on this website is provided for general information. While we work to keep it accurate and current, we do not warrant that all content is complete, error-free or up to date at all times, and content may change without notice.",
    ],
  },
  {
    heading: "Intellectual Property",
    paragraphs: [
      "The 30 NORTH name, logo, brand elements and the content of this website are the property of 30 North Transportation Inc. You may not copy, reproduce or use them without our written permission.",
    ],
  },
  {
    heading: "Limitation of Liability",
    paragraphs: [
      "This website and its content are provided on an \u201cas is\u201d basis. To the fullest extent permitted by law, 30 North Transportation Inc. is not liable for any indirect, incidental or consequential damages arising from your use of, or inability to use, this website or its content.",
      "Nothing on this website constitutes a guarantee of transportation availability, timing or pricing.",
    ],
  },
  {
    heading: "Privacy",
    paragraphs: [
      "Your use of this website is also subject to our Privacy Policy, which explains how we collect and handle personal information.",
    ],
  },
  {
    heading: "Changes to These Terms",
    paragraphs: [
      "We may update these Terms & Conditions from time to time. The current version will always be posted on this page with its updated date.",
    ],
  },
  {
    heading: "Governing Law",
    paragraphs: [
      "These Terms & Conditions are governed by the laws of the Province of Ontario and the federal laws of Canada applicable in Ontario.",
    ],
  },
  {
    heading: "Contact Information",
    paragraphs: [
      "If you have any questions about these Terms & Conditions, please contact us using the details below.",
    ],
  },
];

export default function TermsAndConditions() {
  return (
    <LegalPage
      title="Terms & Conditions"
      description="Review the Terms & Conditions governing use of the 30 NORTH website and transportation quote requests."
      path="/terms-and-conditions"
      updated="July 2026"
      intro="These Terms & Conditions apply to www.30north.ca and to the quote request and contact features offered through it."
      sections={SECTIONS}
      testid="terms-page"
    />
  );
}
